export default __webpack_public_path__ + "alberta-ic-edit.40c70f88196c13ee80e3.svg";